<template>
  <section id="input-bar">
    <div id="salary-button">
      ENTER YOUR SALARY
      <input id="salary-input" v-model="mySalary" type="number" />
    </div>
    <nav-tabs id="nav"></nav-tabs>
  </section>
</template>

<style lang="scss" scoped>
#input-bar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding:20px;
  color:$grey;

  @include respond(desktop-sm) {
    flex-direction: column;
  }
}

#salary-button {
  background: linear-gradient($highlight1, $highlight2);
  border-radius: 60px;
  padding: 10px 20px 10px 20px;
  font-size: 16px;
  font-weight: bold;
  order: 1;
  @include respond(desktop-sm) {
    order: 2;
  }
   @include respond(phone-only){
      font-size:14px;
      text-align: center;
      padding: 20px 10px 20px 10px;
   }
}

#nav {
  order: 2;
  @include respond(desktop-sm) {
    order: 1;
    margin-bottom:20px;
  }
}

#salary-input {
  border-radius: 30px;
  border: none;
  padding: 5px;
  margin: 0px 0px 0px 10px;
  font-size: 16px;
  font-weight: bold;
  color: $text_grey1; 
  @include respond(phone-only){
     margin: 10px 0px 0px 0px;
  } 
}
</style>

<script>
import NavTabs from "@/components/Shared/NavTabs";
export default {
  components: {
    NavTabs,
  },
  data() {
    return {
      mySalary: 0,
    };
  },
  watch: {
    mySalary: function () {
      this.$store.commit("setMySalary", { mySalary: this.mySalary });
    },
  },
};
</script>